import React from 'react';
import Ingredient from '../Ingredient/Ingredient';
import './Burger.css';

const Burger = props => {
    let ingredientArr = props.ingredients.map(item => {
        return [...Array(item.amount).keys()].map(_ => {
            return <Ingredient type={item.type} key={Math.random()} />
        })
    })
        .reduce((arr, element) => {
            return arr.concat(element)
        }, []);

    if (ingredientArr.length <= 0) {
        ingredientArr = <p>Please add Some Ingredients !..</p>
    }

    return (
        <div className='container'>
            <div className='Burger'>
                <Ingredient type='bread-top' />
                {ingredientArr}
                <Ingredient type='bread-bottom' />
            </div>
        </div>
    );
}

export default Burger;